import { useTheme } from '@material-ui/core/styles';
import { Pagination } from '@material-ui/lab';
import React from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from '../../../../services/booleanUtil';
import { AppMenuTabs } from '../../../MenuTabs/userTabsInterface';
// EmptySearchResult removed — message handled by table components when needed
import { ProjectsTable } from '../../ProjectsTable/ProjectsTable';
import { TabPanel } from '../ProjectAllUtil';
import '../../../Util/Pagination/Pagination.scss';

type Props = {
  projects: any;
  numberOfPages: any;
  numberOfProjects: any;
  setInFollow: any;
  sortTable: any;
  initialPage: any;
  handleChangePaginate: any;
  searchValue?: string;
};

export const ProjectsAllTable = ({
  projects,
  numberOfPages,
  numberOfProjects,
  setInFollow,
  sortTable,
  initialPage,
  handleChangePaginate,
  searchValue,
}: Props) => {
  const theme = useTheme();
  const { isAnnual } = useSelector<any, any>(state => state.filter.common);
  const { projectSelectedTab } = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  return (
    <TabPanel
      key={projectSelectedTab.internalId}
      value={projectSelectedTab.internalId}
      index={projectSelectedTab.internalId}
      dir={theme.direction}
    >
      <ProjectsTable
        projects={projects}
        setInFollow={setInFollow}
        sortTable={sortTable}
        isAnnual={isAnnual}
        fnPaginacion={handleChangePaginate}
        initialPage={initialPage}
        numberOfPages={numberOfPages}
        numberOfProjects={numberOfProjects}
        searchValue={searchValue}
        selectable={true}
      />
    </TabPanel>
  );
};
